import cx from "classnames";
import styles from "modules/finances/widgets/month-plan-list/ui/month-plan-next/month-plan-next-entity.module.scss";
import React, { CSSProperties } from "react";
import { MonthPlanCommonNextMonthPlanDto } from "shared/api";
import { capitalize, formatDate } from "shared/lib";
import { Button, Entity } from "shared/ui";

export interface IMonthPlanNextEntity {
  data: MonthPlanCommonNextMonthPlanDto;

  onCreate: (data: MonthPlanCommonNextMonthPlanDto) => void;

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const MonthPlanNextEntity = (props: IMonthPlanNextEntity) => (
  <Entity className={cx(styles.month_plan_next_entity, props.className)} style={props.style} htmlId={props.htmlId}>
    <div style={{ width: 20 }}></div>
    <Entity.Field
      title={capitalize(new Date(props.data.year, props.data.month - 1).toLocaleString("ru-RU", { month: "long" }))}
      description={
        <span className={styles.primary}>
          {formatDate(props.data.from)} — {formatDate(props.data.to)}
        </span>
      }
    />

    <Entity.Actions>
      <Button type="secondary" size="small" onClick={() => props.onCreate(props.data)} style={{ marginLeft: "auto" }}>
        Спланировать
      </Button>
    </Entity.Actions>
  </Entity>
);

MonthPlanNextEntity.defaultProps = {};
